module.exports = __webpack_public_path__ + "static/media/age.977cf6c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plants/age.jpg
// module id = 721
// module chunks = 12